import _defineProperty from "/builds/unifygroup/uno/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty";
import _asyncToGenerator from "/builds/unifygroup/uno/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import _regeneratorRuntime from "/builds/unifygroup/uno/app/node_modules/next/dist/compiled/@babel/runtime/regenerator";
import differenceBy from 'lodash/differenceBy';
import isEqual from 'lodash/isEqual';
import omit from 'lodash/omit';
import uniqBy from 'lodash/uniqBy';
import { useCallback, useState } from 'react';
import { useFormContext } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import { ContentStatus, PublicationStatus } from '@uno/common-cms';
import { contentToEnvelope, triggerPublicationFromUrlItems } from 'libs/content/utils';
import { getFirstLoadContent, getUrls, updateFirstLoadContent, updateUrls } from 'redux/content';
import { createPage, generateUrls } from 'services/networking/navigation';
import useSaveContent from './useSaveContent';

var getUrlsToCreate = function getUrlsToCreate(generatedUrls, existingUrls) {
  if (existingUrls === undefined) {
    return generatedUrls !== null && generatedUrls !== void 0 ? generatedUrls : [];
  }

  if (generatedUrls === undefined) {
    return existingUrls !== null && existingUrls !== void 0 ? existingUrls : [];
  }

  return differenceBy(generatedUrls, existingUrls, 'pageType');
};

var publicationToContentStatus = function publicationToContentStatus(publicationStatus) {
  if (publicationStatus === undefined) {
    return undefined;
  }

  return publicationStatus === PublicationStatus.OFFLINE ? ContentStatus.OFFLINE : ContentStatus.READY;
};

var triggerPublicationStepFunctions = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
    var content, publicationData, currentPublicationStatus, currentPublishAt, urls, contentUpdated, publicationStatus, scheduledPublicationDate;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            content = _ref.content, publicationData = _ref.publicationData, currentPublicationStatus = _ref.currentPublicationStatus, currentPublishAt = _ref.currentPublishAt, urls = _ref.urls, contentUpdated = _ref.contentUpdated;
            publicationStatus = publicationData.publicationStatus, scheduledPublicationDate = publicationData.scheduledPublicationDate;

            if (!(publicationStatus !== undefined && urls !== undefined && (currentPublicationStatus !== publicationStatus || publicationStatus === PublicationStatus.SCHEDULED && (scheduledPublicationDate === null || scheduledPublicationDate === void 0 ? void 0 : scheduledPublicationDate.toISOString()) !== currentPublishAt))) {
              _context.next = 5;
              break;
            }

            _context.next = 5;
            return triggerPublicationFromUrlItems(content.id, publicationData, urls, contentUpdated);

          case 5:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function triggerPublicationStepFunctions(_x) {
    return _ref2.apply(this, arguments);
  };
}();

var useSubmitContent = function useSubmitContent(publicationData, currentPublicationStatus, currentPublishAt) {
  var _useState = useState(false),
      isPublishing = _useState[0],
      setPublishing = _useState[1];

  var _useSaveContent = useSaveContent(),
      doSaveContent = _useSaveContent.doSaveContent;

  var _useSelector = useSelector(getUrls),
      existingUrls = _useSelector.value;

  var _useSelector2 = useSelector(getFirstLoadContent),
      firstLoadContent = _useSelector2.value;

  var dispatch = useDispatch();

  var _useFormContext = useFormContext(),
      getValues = _useFormContext.getValues;

  var handleSubmit = useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
    var publicationStatus, contentData, content, contentUpdated, generatedUrls, urlsToCreate, _iterator, _step, urlToCreate, cleanedExistingUrls;

    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            publicationStatus = publicationData.publicationStatus;

            if (!(publicationStatus === undefined || firstLoadContent === undefined)) {
              _context2.next = 3;
              break;
            }

            return _context2.abrupt("return");

          case 3:
            contentData = getValues();
            content = _objectSpread(_objectSpread({}, firstLoadContent), {}, {
              contentData: contentData
            }); // compare initial contentData with new contentData based on form values

            contentUpdated = !isEqual(firstLoadContent.contentData, // use this conversion to remove all potential object keys with "undefined" value (necessarily missing in initial contentData coming from DynamoDB) leading to an inconsistent comparison
            JSON.parse(JSON.stringify(contentData)));

            if (!(publicationStatus !== PublicationStatus.OFFLINE)) {
              _context2.next = 33;
              break;
            }

            setPublishing(true);
            _context2.next = 10;
            return generateUrls(contentToEnvelope(content));

          case 10:
            generatedUrls = _context2.sent;
            urlsToCreate = getUrlsToCreate(generatedUrls, existingUrls); // create pages

            _iterator = _createForOfIteratorHelper(urlsToCreate);
            _context2.prev = 13;

            _iterator.s();

          case 15:
            if ((_step = _iterator.n()).done) {
              _context2.next = 21;
              break;
            }

            urlToCreate = _step.value;
            _context2.next = 19;
            return createPage(_objectSpread(_objectSpread({}, omit(urlToCreate, 'pageType')), {}, {
              mainChunkId: content.id
            }));

          case 19:
            _context2.next = 15;
            break;

          case 21:
            _context2.next = 26;
            break;

          case 23:
            _context2.prev = 23;
            _context2.t0 = _context2["catch"](13);

            _iterator.e(_context2.t0);

          case 26:
            _context2.prev = 26;

            _iterator.f();

            return _context2.finish(26);

          case 29:
            // update urls
            cleanedExistingUrls = (existingUrls !== null && existingUrls !== void 0 ? existingUrls : []).map(function (url) {
              return omit(url, 'absoluteUrl');
            });
            dispatch(updateUrls({
              value: uniqBy(cleanedExistingUrls.concat(generatedUrls !== null && generatedUrls !== void 0 ? generatedUrls : []), 'pageType')
            })); // Trigger publication for new urls not in existingUrls

            _context2.next = 33;
            return triggerPublicationStepFunctions({
              content: content,
              publicationData: publicationData,
              currentPublicationStatus: currentPublicationStatus,
              currentPublishAt: currentPublishAt,
              urls: urlsToCreate,
              contentUpdated: contentUpdated
            });

          case 33:
            _context2.next = 35;
            return triggerPublicationStepFunctions({
              content: content,
              publicationData: publicationData,
              currentPublicationStatus: currentPublicationStatus,
              currentPublishAt: currentPublishAt,
              urls: existingUrls,
              contentUpdated: contentUpdated
            });

          case 35:
            _context2.next = 37;
            return doSaveContent(content.id, {
              contentData: content.contentData,
              status: publicationToContentStatus(publicationStatus)
            });

          case 37:
            dispatch(updateFirstLoadContent({
              loading: false
            }));
            setPublishing(false);

          case 39:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[13, 23, 26, 29]]);
  })), [publicationData, firstLoadContent, getValues, currentPublicationStatus, currentPublishAt, existingUrls, doSaveContent, dispatch]);
  return {
    isPublishing: isPublishing,
    handleSubmit: handleSubmit
  };
};

export default useSubmitContent;